import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { class: "d-flex justify-content-center w-100 align-items-center gap-xs" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "",
    title: _ctx.$t('labels.android_apps'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      (_ctx.qrCodeKey)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                value: _ctx.qrCodeKey,
                readonly: ""
              }, null, 8, _hoisted_3),
              _createVNode(_component_copy_button, { value: _ctx.qrCodeKey }, null, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.qrCodeValue)
          ? (_openBlock(), _createBlock(_component_vue_qrcode, {
              key: 0,
              value: _ctx.qrCodeValue,
              tag: "svg",
              style: {"border-radius":"10px","max-width":"400px"},
              class: "w-100",
              options: { width: '100%' }
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}